import validatorsByFields from '@/utils/validations/validatorsByFields'
import { required } from 'vuelidate/lib/validators'
import { slugValidator, slugAsyncValidator, validationErrorMessages } from '@/utils/validations/validations'
import eventCategorySlugQuery from '@/services/gql/types/EventCategories/queries/eventCategoriesSlugs.gql'
const { title, sortOrder } = validatorsByFields

export default ({ id, ctx, isNew }) => {
  const isUnique = async (value) => {
    return await slugAsyncValidator(value, id, eventCategorySlugQuery, ctx, 'eventCategories')
  }
  return {
    title,
    slug: (() => {
      if (isNew) { return false }
      return {
        required: { validator: required, message: validationErrorMessages.required },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique },
        generalValidation: { validator: slugValidator, message: validationErrorMessages.slugGeneralMsg }
      }
    })(),
    sortOrder
  }
}
